import { Button } from '@mantine/core';
import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { signInWithGoogle } from '../util/googleAuth';

/**
 * Interactive Google Sign-In fallback when automatic SSO fails.
 *
 * @see {@link https://developers.google.com/identity/gsi/web/guides/display-button#javascript}
 */
export const GoogleSignInButton = () => {
  const { setToken } = useAuth();
  const [isSigningIn, setIsSigningIn] = useState(false);

  async function signIn() {
    if (isSigningIn) return;

    setIsSigningIn(true);
    try {
      const session = await signInWithGoogle();
      setToken(session);
    } catch {
      // Leave the user on the login page to retry.
    } finally {
      setIsSigningIn(false);
    }
  }

  return (
    <Button onClick={signIn} variant="outline" loading={isSigningIn}>
      Sign in with Google
    </Button>
  );
};
